<template>
  <router-view />

  <div class="container footer">
    <div class="navbar">
      <router-link class="nav-link" to="/privacy">Privacy</router-link>
      <router-link class="nav-link" to="/terms">Terms</router-link>
    </div>
    <router-link to="/">
      <img
        alt="Grub's up logo"
        width="50"
        height="50"
        src="@/assets/logo.svg"
      />
    </router-link>
    <div class="m-auto">
      <p>Copyright © Grub’s up 2022</p>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/scss/main.scss";
</style>
<script>
export default {
  data() {
    return {
      //
    };
  },
  mounted() {
    document.title = "Grub's up | Grocery manager";
  },
};
</script>